<template>
  <div class="btn-group w-100">
    <input
      ref="dropdownInput"
      class="form-control dropdown-toggle cursor-pointer"
      readonly
      data-bs-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      :placeholder="$t('page.serviceEvaluation')"
      :value="selectedLabel"
      :title="selectedLabel"
    />
    <div class="dropdown-menu dropdown-menu-md p-4" @click.stop>
      <div class="group" v-for="(group, gidx) in selectOptions" :key="gidx">
        <div class="group-title my-2">{{ group.label }}</div>
        <div class="group-content d-flex justify-content-between">
          <span
            v-for="(item, index) in group.options"
            :key="index"
            class="item-title rounded px-3 py-2 cursor-pointer"
            :class="[selectedValue.includes(item.value) ? 'active' : '']"
            @click.stop="selectItem(item)"
          >
            {{ item.label }}
          </span>
        </div>
      </div>
      <div class="mt-3 mb-1 text-end">
        <button
          class="btn btn-light bg-gradient waves-effect waves-light btn-sm me-2"
          @click="reset"
        >{{ $t('base.reset') }}</button>
        <button
          class="btn btn-primary bg-gradient waves-effect waves-light btn-sm"
          @click="done"
        >{{ $t('base.done') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { ref, getCurrentInstance, watchEffect } from 'vue'


export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const instance = getCurrentInstance()
    const $t = instance.appContext.config.globalProperties.$t
    // console.log(props.value)
    const filterOptions = [
      {
        label: $t('page.serviceQuality'),
        options: [
          {
            value: 'quality_bad',
            label: $t('page.less-than-3-points'),
          },
          {
            value: 'quality_good',
            label: $t('page.more-than-3-points'),
          },
        ],
      },
      {
        label: $t('page.serviceAttitude'),
        options: [
          {
            value: 'attitude_bad',
            label: $t('page.less-than-3-points'),
          },
          {
            value: 'attitude_good',
            label: $t('page.more-than-3-points'),
          },
        ],
      },
      {
        label: $t('page.responseSpeed'),
        options: [
          {
            value: 'response_speed_bad',
            label: $t('page.less-than-3-points'),
          },
          {
            value: 'response_speed_good',
            label: $t('page.more-than-3-points'),
          },
        ],
      },
    ]
    const selectOptions = ref(filterOptions)
    const selectedValue = ref([])
    const selectedLabel = ref('')

    function selectItem(item) {
      if (selectedValue.value.includes(item.value)) {
        _.remove(selectedValue.value, (i) => i === item.value)
      } else {
        const prefix = item.value.split('_')[0]
        // 移除同一组的选项
        _.remove(selectedValue.value, (i) => i.split('_')[0] === prefix)
        selectedValue.value.push(item.value)
      }
    }

    function reset() {
      selectedValue.value = []
      selectedLabel.value = ''
      hide()
      instance.emit('update:value', [])
    }

    function done() {
      selectedLabel.value = getSelectedLabel()
      hide()
      instance.emit('update:value', selectedValue.value)
    }

    function hide() {
      let dropdownElement = instance.refs.dropdownInput;
      dropdownElement.click();
    }

    function getSelectedLabel() {
      const label = []
      selectOptions.value.forEach((group) => {
        group.options.forEach((item) => {
          if (selectedValue.value.includes(item.value)) {
            label.push(group.label + ':' +item.label)
          }
        })
      })
      return label.join(',')
    }

    watchEffect(() => {
      selectedValue.value = props.value
      selectedLabel.value = getSelectedLabel()
    })


    return {
      selectOptions,
      selectedValue,
      selectedLabel,
      selectItem,
      reset,
      done,
    }
  },
}
</script>
<style scoped lang="scss">
.item-title {
  background-color: #F3F6F9;
}
.item-title.active {
  background-color: rgba(67, 80, 133, 0.10);
  color: #38477E;
}
</style>
